import React from "react";

/**
 * K.S.E. Inc. wordmark — "K.S.E.INC" in a high-contrast Didone serif with
 * "EST. 1998" letter-spaced beneath, matching the official logo artwork.
 * Rendered as vector text so it stays crisp at any size and inherits colour:
 * white on the navy header/footer, ink on light backgrounds.
 *
 * Props:
 *   size  — "sm" | "md" | "lg" | "xl"   (height in px: 30 / 40 / 64 / 110)
 *   tone  — "light" (white) | "dark" (ink)
 */
const HEIGHTS = { sm: 30, md: 40, lg: 64, xl: 110 };
const SERIF = "'Bodoni Moda', 'Bodoni 72', Didot, 'Playfair Display', Georgia, 'Times New Roman', serif";
const SANS = "Poppins, Inter, 'Helvetica Neue', Arial, sans-serif";

export default function Logo({ size = "md", tone = "light", className = "" }) {
  const h = HEIGHTS[size] || HEIGHTS.md;
  const color = tone === "dark" ? "#0b0b0b" : "#ffffff";
  return (
    <svg
      viewBox="0 0 1340 440"
      height={h}
      width={Math.round(h * (1340 / 440))}
      role="img"
      aria-label="K.S.E. Inc. — Est. 1998"
      className={`kse-wordmark select-none ${className}`}
      style={{ color, display: "block" }}
    >
      <text
        x="670"
        y="262"
        textAnchor="middle"
        fontFamily={SERIF}
        fontWeight="400"
        fontSize="250"
        letterSpacing="14"
        fill="currentColor"
      >
        K.S.E.INC
      </text>
      <text
        x="670"
        y="378"
        textAnchor="middle"
        fontFamily={SANS}
        fontWeight="600"
        fontSize="84"
        letterSpacing="48"
        fill="currentColor"
      >
        EST. 1998
      </text>
    </svg>
  );
}
